/// <reference path="./index.d.ts" />
/**
 * Size-optimized onnxruntime-web export with only WASM backend included.
 * This trick reduces the bundle size by 562Kb (132Kb gzipped) of JavaScript code.
 */

import { simd as detectSimdSupport } from "wasm-feature-detect"
import Wasm from "/node_modules/onnxruntime-web/dist/ort-wasm-simd.wasm?url"
import WasmNoSimd from "/node_modules/onnxruntime-web/dist/ort-wasm.wasm?url"

export { env, InferenceSession, Tensor, type Env } from "onnxruntime-web"

const isSimdSupported = await detectSimdSupport()

export const getONNXWasm = async () => {
  return {
    numThreads: 1,
    url: isSimdSupported ? Wasm : WasmNoSimd,
    name: isSimdSupported ? "ort-wasm-simd.wasm" : "ort-wasm.wasm",
    type: "application/wasm",
  }
}
